export enum ResumeQuizSettingType {
  NO = 'NO',
  YES_TIMER_RUNNING = 'YES_TIMER_RUNNING'
}
